import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { Toaster } from "sonner";
import { PlayerProvider, usePlayer } from "@/context/PlayerContext";
import { stationByUuid } from "@/lib/api";
import { Layout } from "@/components/Layout";
import Discover from "@/pages/Discover";
import Favorites from "@/pages/Favorites";
import History from "@/pages/History";

function DeepLinkHandler() {
  const { play } = usePlayer();
  const [params, setParams] = useSearchParams();

  useEffect(() => {
    const id = params.get("station");
    if (!id) return;
    stationByUuid(id).then((st) => {
      if (st) play(st);
    });
    params.delete("station");
    setParams(params, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

function App() {
  return (
    <div className="App">
      <PlayerProvider>
        <BrowserRouter>
          <DeepLinkHandler />
          <Layout>
            <Routes>
              <Route path="/" element={<Discover />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/history" element={<History />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#141419",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#FAFAFA",
            },
          }}
        />
      </PlayerProvider>
    </div>
  );
}

export default App;
